import type { AppEnvironment } from './environment.js';

/**
 * Local-dev-only fallback. Preview/production URLs are NOT hardcoded here —
 * they are unknown until the Worker and Pages projects are actually deployed
 * in Phase 1+, so they must be supplied via environment variables
 * (VITE_API_BASE_URL for the web app, see docs/environment-variables.md).
 * This keeps the "no hardcoded URLs" rule honest instead of just moving the
 * hardcoding from call sites into this file.
 */
const LOCAL_DEV_API_BASE_URL = 'http://localhost:8787';

export interface ResolveApiBaseUrlInput {
  environment: AppEnvironment;
  /** Value of VITE_API_BASE_URL / API_BASE_URL, when known. */
  configuredUrl?: string;
}

export function resolveApiBaseUrl({ environment, configuredUrl }: ResolveApiBaseUrlInput): string {
  if (configuredUrl && configuredUrl.length > 0) {
    return configuredUrl;
  }
  if (environment === 'development') {
    return LOCAL_DEV_API_BASE_URL;
  }
  throw new Error(
    `No API base URL configured for environment "${environment}". Set VITE_API_BASE_URL (web) or API_BASE_URL (worker).`,
  );
}
